import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})

export class MaturidadeService {
  private apiUrl = environment.apiUrl;
  maturidadeUrl = `${this.apiUrl}public/maturidade/`;

  constructor(private _http: HttpClient) {
  }

  getMaturidadeEmpresa(empresaId): Observable<any[]> {
    return this._http.get(`${this.maturidadeUrl}maturidade/${empresaId}`)
      .pipe(map(data => {
        return <any[]>data;
      }));
  }


  getMaturidadeEmpresaPeriodoColaboradores(empresaId, ano, mes): Observable<any[]> {
    return this._http.get(`${this.maturidadeUrl}colaboradores/${empresaId}/${ano}/${mes}`)
      .pipe(map(data => {
        return <any[]>data;
      }));
  }

  getMaturidadeEmpresaPeriodoColaborador(empresaId, ano, mes, nomeColaborador): Observable<any[]> {
    return this._http.get(`${this.maturidadeUrl}colaborador/${empresaId}/${ano}/${mes}/${nomeColaborador}`)
      .pipe(map(data => {
        return <any[]>data;
      }));
  }

  insertMaturidadeEmpresa(empresaId, maturidade) {
    return this._http.post(`${this.maturidadeUrl}${empresaId}`, maturidade)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  enviarMaturidadeEmpresa(empresaId, maturidade) {
    return this._http.post(`${this.maturidadeUrl}envio/${empresaId}`, maturidade)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  private handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
